import Cookies from 'js-cookie'

export function clearMemberCache() {
  removeMember();
}

// 用户信息
const MemberKey = 'Member-Info'

export function getMember() {
  let member = Cookies.get(MemberKey);
  if (member) {
    member = JSON.parse(member);
  }
  return member;
}

export function setMember(member) {
  return Cookies.set(MemberKey, member);
}

export function removeMember() {
  return Cookies.remove(MemberKey);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js